import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    borderRadius: theme.spacing(1.5),
    padding: theme.spacing(.5),
    paddingLeft: theme.spacing(1.2),
    paddingRight: theme.spacing(1.2),            
    fontSize: '.8rem',
    display: 'inline-block'
  },
})

const StatusLabel = ({ classes, children, color }) => {
  const backgroundColor = color || '#555'
  const textColor = '#fff'
  
  return (
    <div 
      className={classes.root} 
      style={{ 
        backgroundColor,
        color: textColor,
      }}
      >
      { children }
    </div>
  )
}

export default withStyles(styles)(StatusLabel)